import styled from 'styled-components';

export const SettingStyle = styled.div`
  width: 100%;
  min-height: 100%;
  padding: 28px 28px 40px;
  font-size: 16px;
  line-height: 1.55;
  position: relative;
  display: flex;
  flex-direction: column;
  color: var(--ink);
  background: var(--paper);

  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;

    h1 {
      margin: 0;
      font-size: 28px;
      font-weight: 600;
      letter-spacing: -0.035em;
      color: var(--ink);
    }

    .btn-menu {
      flex-shrink: 0;
      width: 40px;
      font-size: 30px;
      line-height: 1;
      padding: 5px 5px 0;
      border-radius: 9999px;
      background: var(--ink);
      color: var(--paper);

      @media (min-width: 992px) {
        display: none;
      }
    }
  }
`;

export const TabsWrap = styled.div`
  position: relative;
  display: flex;
  flex-grow: 1;
  gap: 28px;
  align-items: flex-start;

  .tab-btns {
    position: fixed;
    left: 0;
    flex-shrink: 0;
    width: 280px;
    padding: 16px;
    border: 1px solid var(--line);
    border-radius: 0 var(--r-lg) var(--r-lg) 0;
    background: var(--paper-2);
    transition: all var(--ease) 0.4s;
    transform: translateX(-350px);
    z-index: 3;

    &.show {
      transform: translateX(0);
    }

    @media (min-width: 992px) {
      width: 240px;
      transform: none;
      position: sticky;
      top: 24px;
      background: transparent;
      border: none;
      border-right: 1px solid var(--line);
      border-radius: 0;
      padding: 0 20px 0 0;
    }

    .holder {
      width: 100%;
      margin-bottom: 8px;
    }

    .subtitle {
      display: block;
      font-family: var(--font-mono);
      font-size: 11px;
      line-height: 1.4;
      font-weight: 500;
      letter-spacing: 0.16em;
      color: var(--mute);
      text-transform: uppercase;
      margin: 20px 0 10px;

      &:first-child {
        margin-top: 0;
      }
    }

    .btn {
      display: block;
      width: 100%;
      font-size: 14px;
      line-height: 1.4;
      font-weight: 500;
      text-align: left;
      padding: 10px 12px;
      border-radius: 9999px;
      margin: 0 0 4px;
      color: var(--ink);
      transition: background 0.2s var(--ease), color 0.2s var(--ease);

      &:hover {
        background: var(--white);
        color: var(--ink);
      }

      &.active {
        background: var(--white);
        color: var(--space);
        font-weight: 600;
        box-shadow: var(--shadow-soft);
      }
    }
  }

  .tab-content {
    flex-grow: 1;
    min-width: 0;
    max-width: 720px;
    padding-top: 4px;
    color: var(--ink);

    > p {
      margin: 0;
      padding: 18px 20px;
      background: var(--white);
      border: 1px solid var(--line);
      border-radius: var(--r-lg);
      box-shadow: var(--shadow-soft);
      color: var(--mute);
      font-size: 15px;
      line-height: 1.55;
    }
  }
`;
